import React from 'react'
import { SVGIconProps } from '../types'
const SvgFastForward = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="m4 18 8.5-6L4 6zm9-12v12l8.5-6z" />
  </svg>
)
export default SvgFastForward
